import React, { useEffect, useState } from 'react';
import useSetState from '../../../../hooks/useSetState';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../../../../components/table';
import { packagesReportListColumns } from '../../../../enums/columns/packagesReportList';
import PackagesReportTabFilters from '../filters/packagesReportTabFilters';
import {
  getRseePackagesSalesReportRequest,
  getAllRseePackagesRequest,
} from '../../../../redux/rseePackages/actions';
import submitForm from '../../../../utils/submitForm';

const PackagesReportTab = () => {
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    filter: '',
    sort: { sortType: 'desc', sortBy: 'date', sortQuery: '', filterQuery: '' },
    query: '',
    pageNumber: 1,
    pageSize: 10,
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const {
    rseePackagesSalesReport,
    rseePackagesSalesReportTotalRecords,
    getRseePackagesSalesReportLoading,
    rseePackagesList,
    sumTotalBoughtRsee,
    sumTotalPaidPrice,
  } = useSelector(state => ({
    rseePackagesSalesReport: state.rseePackagesReducer.rseePackagesSalesReport,
    getRseePackagesSalesReportLoading:
      state.rseePackagesReducer.getRseePackagesSalesReportLoading,
    rseePackagesSalesReportTotalRecords:
      state.rseePackagesReducer.rseePackagesSalesReportTotalRecords,
    rseePackagesList: state.rseePackagesReducer.rseePackagesList,
    sumTotalBoughtRsee: state.rseePackagesReducer.sumTotalBoughtRsee,
    sumTotalPaidPrice: state.rseePackagesReducer.sumTotalPaidPrice,
  }));

  const getRseePackagesSalesReport = (pageNumber, pageSize) => {
    const query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    dispatch(getRseePackagesSalesReportRequest(query))
      .then(result => {
        onChangeValue('pageNumber', result.payload.pageNumber);
        onChangeValue('pageSize', result.payload.pageSize);
      })
      .catch(error => console.log('error', error));
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${controls.sort.sortQuery || 'date-desc'}`;
      if (controls.sort.filterQuery) {
        query += '&' + controls.sort.filterQuery;
      }
      return query;
    }
  };

  const sortTable = columnName => {
    const sortType = controls.sort.sortType === 'asc' ? 'desc' : 'asc';
    onChangeValue('sort', { ...controls.sort, sortType, sortBy: columnName });
  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(1, controls.pageSize);
    dispatch(getRseePackagesSalesReportRequest(searchQuery));
  };

  const applyFilters = (event, name, fromDate, toDate) => {
    event.preventDefault();
    const queryString = submitForm(event, name, fromDate, toDate);
    onChangeValue('sort', { ...controls.sort, filterQuery: queryString });
  };

  const resetForm = () => {
    onChangeValue('pageNumber', 1);
    onChangeValue('sort', { ...controls.sort, filterQuery: '' });
  };

  const onPageChanged = pageNumber => {
    onChangeValue('pageNumber', pageNumber);
    let query = `pageNumber=${pageNumber}&pageSize=${controls.pageSize}`;
    dispatch(getRseePackagesSalesReportRequest(query));
  };

  useEffect(() => {
    const query = `pageNumber=${1}&pageSize=${10}`;
    dispatch(getAllRseePackagesRequest(query));
  }, []);

  useEffect(() => {
    sortTable(controls.sort.sortBy);
  }, []);

  useEffect(() => {
    const sortQuery = `${controls.sort.sortBy}-${controls.sort.sortType}`;
    onChangeValue('sort', { ...controls.sort, sortQuery });
  }, [controls.sort.sortType]);

  useEffect(() => {
    if (controls.sort.sortQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.sortQuery]);

  useEffect(() => {
    if (controls.sort.filterQuery !== '') {
      onChangeValue('pageNumber', 1);
      filterAndSort();
    }
  }, [controls.sort.filterQuery]);

  return (
    <section>
      <PackagesReportTabFilters
        data={rseePackagesList}
        pageNumber={controls.pageNumber}
        pageSize={controls.pageSize}
        applyFilters={applyFilters}
        getRseePackagesSalesReport={getRseePackagesSalesReport}
        resetForm={resetForm}
      />

      <div className='bg-white p-2'>
        <div className=''>
          <div className='row mb-2 justify-content-between px-3'>
            <div className='col-md-6'>
              <div className='row'>
                <label className=' text-right filter-field-label'>
                  {locales('sum.total.paid.price.to.buy.package')}
                </label>
                <div className='mr-2'>
                  {Number(sumTotalPaidPrice).toLocaleString()}
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='row'>
                <label className=' text-right filter-field-label'>
                  {locales('sum.total.bought.rsee')}
                </label>
                <div className='mr-2'>
                  {Number(sumTotalBoughtRsee).toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='panel-heading'>
          <i className='fas fa-list-alt px-1' />
          {locales('packages')}
        </div>
        <div className='table-responsive-lg'>
          <Table
            columns={packagesReportListColumns}
            dataSource={rseePackagesSalesReport}
            loading={getRseePackagesSalesReportLoading}
            sort={{ type: controls.sort.sortType, action: sortTable }}
            pagination={{
              currentPage: controls.pageNumber,
              pageSize: controls.pageSize,
              totalCount: rseePackagesSalesReportTotalRecords,
              onPageChange: onPageChanged,
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default PackagesReportTab;
